import React, { useEffect, Suspense, useState } from "react";
import {Loader, LoadingOverlay} from '@mantine/core';

import { gridBackgroundStyle, projectStyle } from "../styleFile.js";
 
import { Button, Grid } from "@mui/material/";
import Box from '@mui/material/Box';
import AddIcon from '@mui/icons-material/Add';
import { useAccountStore } from "../zustand/account";
import { useObjectStore } from "../zustand/objects";
import { Typography } from '@mui/material';

import AppNavBar from "../components/AppNavBar";

import DeleteProjectModal from "../components/DeleteProjectModal";
import ProjectsTable from "../components/ProjectsTable";
import {getGuestProjectsAPI} from "../api";

const ProjectsPage = () => {

  const [guestProjects, setGuestProjects] = useState()
  const [loading, setLoading] = useState(true)

  const getGuestProjects = () => {
    getGuestProjectsAPI().then(res => setGuestProjects(res))
  }

    const { projects, createNewProject, duplicateExistingProject, getUserProjects, deleteID, userStatus } = useAccountStore();
    const { loadObjects, getAIModels, objectsAreLoaded } = useObjectStore();

    // Get existing projects on page load, thenn hide 'loader'
    useEffect(() => {
        getProjects().then(() => setLoader())
    }, [])

    // Load user's projects from database
    async function getProjects() {
        getAIModels()
        getUserProjects()
        getGuestProjects()
    }

    // Hide loader
    const setLoader = () => {
        loadObjects()
        setLoading(false)
    }


    // Submit new project
    const handleSubmit = (e) => {
        setLoading(true)
        sendProject(e)
        .then(() => setTimeout(() => {
            getProjects();
          }, "400")) 
        .then(() => setLoader())
    } 

    // Copy existing project
    const handleCopySubmit = (e) => {
        setLoading(true)
        sendDuplicateProject(e)
        .then(() => setTimeout(() => {
            getProjects();
          }, "400")) 
        .then(() => setLoader())
    }
    
    // Send new project to database
    async function sendProject(e) {
        let projectsLength = projects.length
        createNewProject(`Project ${projectsLength += 1}` )
    }
    // Send duplicate project to database
    async function sendDuplicateProject(e) {
        duplicateExistingProject(e)
    }

    const GridBackground = () => {
        return (
            <div style={gridBackgroundStyle}></div>

        )
    }

    return (
        <div>
            <Suspense fallback={<div>Loading... </div>}>
            <DeleteProjectModal deleteID={deleteID} />
            <GridBackground />
            <Grid container>
                <Grid item xs={12}>
                    <AppNavBar pageName={'projects'} />
                </Grid>
                <Grid item xs={12} md={9} sx={{ mt: 8, mb: 4 }}>
                <Box sx={{ marginLeft: 10, flexGrow: 1 }}>
                <LoadingOverlay loaderProps={{ color: 'black' }} visible={loading} zIndex={1000} overlayProps={{ radius: "sm", blur: 2 }} />
 
                            <Typography component="h1" variant="h4" fontWeight={'700'}>
                                Your creations
                            </Typography>
                        </Box> 
                        </Grid>
                        <Grid item xs={12} md={3} sx={{ mt: 8, mb: 2 }}>
                        <Box sx={{  flexGrow: 1 }}>
                        
                        {projects ? (userStatus === 'loggedIn-none' || userStatus === 'loggedIn-canceled') ? 
                        projects.length < 1 ?
                        <Button 
                            onClick={(e) => handleSubmit(e)}
                            size="small" variant="contained"
                            style={projectStyle.projectButton.newProjectButton.active}>
                            <AddIcon />
                            NEW PROJECT
                            </Button>
                        :
                        <Button
                        disabled={true}
                        size="small" variant="contained"
                        style={projectStyle.projectButton.newProjectButton.disabled}>
                        UPGRADE FOR MORE PROJECTS
                        </Button>
                        :<Button
                            onClick={(e) => handleSubmit(e)}
                            size="small" variant="contained"
                            style={projectStyle.projectButton.newProjectButton.active}>
                            <AddIcon />
                            NEW PROJECT
                            </Button> : ''
                            }
                            </Box>
                </Grid>
                <Grid item xs={12}>
                    <Box sx={{ marginLeft: 10, marginBottom: 5, flexGrow: 1 }} noValidate autoComplete="off">
                        <Suspense fallback={<div>Loading... </div>}>
                            {loading ? <Loader color="black" /> : projects && objectsAreLoaded && <ProjectsTable handleCopySubmit={handleCopySubmit} isGuest={false} objectsAreLoaded={objectsAreLoaded} projects={projects} />}
                        </Suspense>
                    </Box>
                </Grid>
                <Grid item xs={12} md={9} sx={{ mt: 0, mb: 4 }}>
                <Box sx={{ marginLeft: 10, flexGrow: 1 }}>
                            <Typography component="h1" variant="h4" fontWeight={'700'}>
                                Creations by others
                            </Typography>
                        </Box>
                        </Grid>
                        <Grid item xs={12}>
                    <Box sx={{ marginLeft: 10, marginBottom: 10, flexGrow: 1 }} noValidate autoComplete="off">

                    <Suspense fallback={<div>Loading... </div>}>
                    {loading ? <Loader color="black" /> : projects && objectsAreLoaded &&<ProjectsTable isGuest={true} objectsAreLoaded={objectsAreLoaded} projects={guestProjects} />}
                        </Suspense>

                    </Box>
                </Grid>


            </Grid>
        </Suspense>

        </div>
    )
};


export default ProjectsPage;
